import { useState, useCallback } from "react";
import { ApiServices } from "services/apiServices";
import * as url from "services/url_helper";
import { dispatchFunction, getItem } from "services/utils";
import { Constants } from "services/keyConstants";
import { useLocation } from "react-router-dom";

// Utility function for handling errors
const handleApiError = (error, customMessage) => {
  console.error(customMessage, error);
  return "An error occurred. Please try again later.";
};
const userData = getItem(Constants.KEY_USER_DATA);

export const CustomHooks = {
  useGetAllRole: () => {
    const [roleData, setRoleData] = useState(null);
    const [roleError, setRoleError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [roleOptions, setRoleOptions] = useState([]);

    const getAllRole = useCallback(async () => {
      setIsLoading(true);
      setRoleError(null);
      try {
        const formatObj = { orgId: userData?.orgId };
        const result = await ApiServices.callServicePostWithBodyData(
          url.GET_ALL_ROLES_API,
          formatObj
        );
        dispatchFunction(result);
        if (result?.response) {
          let designations = result?.result?.data?.map(
            (item) => item?.designation
          );
          let finalDesignations = [...new Set(designations)];
          setRoleOptions(finalDesignations);
          setRoleData(result?.result?.data);
        } else {
          setRoleError("Failed to fetch roles. Please try again.");
        }
      } catch (error) {
        setRoleError(handleApiError(error, "GET_ALL_ROLES ERROR"));
      } finally {
        setIsLoading(false);
      }
    }, []);

    return { roleOptions, roleData, roleError, isLoading, getAllRole };
  },

  useUrlParams: () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    return params;
  },
};
